
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/recruitment-agency",
      function () {
        return require("private-next-pages/solutions/recruitment-agency/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/recruitment-agency"])
      });
    }
  